var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"3610770e9d32bffb80af72a67e5a0f40c6384e45"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["planet-donations@plant-for-the-planet"]={id:"3610770e9d32bffb80af72a67e5a0f40c6384e45"};
      